import {
  Card,
  DialogActions,
  FormControl,
  FormGroup,
  Grid,
  Typography,
} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import CardContent from "@material-ui/core/CardContent";
import Chip from "@material-ui/core/Chip";
import Divider from "@material-ui/core/Divider";
import Fab from "@material-ui/core/Fab";
import Icon from "@material-ui/core/Icon";
import { withStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import Add from "@material-ui/icons/Add";
import CloudUpload from "@material-ui/icons/CloudUpload";
import Search from "@material-ui/icons/Search";
import {
  ExcelExport,
  ExcelExportColumn,
} from "@progress/kendo-react-excel-export";
import axios from "axios";
import DOMPurify from "dompurify";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import { connect } from "react-redux";

import { mapActionsToProps } from "../../redux/miniCrm/contact";
import DialogCampaign from "./../../components/CampaignDialog";
import Dialog from "./../../components/Dialog";
import TableData from "./../../components/TableData";
import * as cookie from "./../../helper/cookie";
import datetimeHelper from "./../../helper/datetime-helper";
import { globalHistory } from "./../../history";
import { mapActionsToProps as CampaignAction } from "./../../redux/campaigns";

const API_PROTOCOL = process.env.REACT_APP_API_PROTOCOL || "";
const API_HOST = process.env.REACT_APP_API_HOST || "";
const API_PATH = process.env.REACT_APP_API_PATH || "";

const dataExcel = [
  {
    phoneNumber: "0982491026",
    name: "Le Van Cuong",
    sex: "male",
    address: "Ha Noi",
    tags: "tags (Cách nhau bằng dấu ;)",
    number: "EJ347605952VN",
  },
];

const styles = (theme) => ({
  model: {
    width: "100%",
  },
  card: {
    maxWidth: "100%",
  },
  form: {
    width: "100%",
  },
  input: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
  },
  chip: {
    margin: theme.spacing.unit,
  },
  fab: {
    margin: theme.spacing.unit * 3,
    whiteSpace: "nowrap",
  },
  // campaign: {
  //     position: 'absolute',
  //     bottom: theme.spacing.unit * 4,
  //     right: theme.spacing.unit * 4,
  // },
  campaignIcon: {
    marginRight: theme.spacing.unit,
  },
  font: {
    fontFamily: theme.typography.fontFamily,
  },
});

class ContactFile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      note: "",
      length: 0,
      data: [],
      modalSend: false,
      filters: {
        order: "createdAt DESC",
        where: {
          gte: null,
          lte: null,
        },
        page: 0,
        pageSize: 20,
      },
      item: null,
      modalEdit: false,
      modalDelete: false,
      modalAction: false,
      selectedFile: null,
      token: "",
      openCampaignConfig: false,
      modelContact: false,
      contact: null,
      container: "",
      error: false,
      errorFileContact: null,
      errorMessage: "Vui lòng chọn file danh bạ",
    };
  }

  _exporter;
  _errorFileExporter;

  async componentDidMount() {
    await this.itemInit();
    this.history = globalHistory();
    this.setState({ token: cookie.getCookie("access_token") });
  }

  listCollumns = [
    {
      id: "name",
      numeric: true,
      disablePadding: false,
      label: "Tên file danh bạ",
    },
    { id: "status", numeric: true, disablePadding: false, label: "Trạng thái" },
    {
      id: "contacts",
      numeric: true,
      disablePadding: false,
      label: "Số lượng danh bạ",
    },
    { id: "note", numeric: true, disablePadding: false, label: "Ghi chú" },
    { id: "config", numeric: true, disablePadding: false, label: "Hành động" },
  ];
  listContact = [
    {
      id: "phoneNumber",
      numeric: true,
      disablePadding: false,
      label: "Số điện thoại",
    },
    { id: "fullName", numeric: true, disablePadding: false, label: "Họ tên" },
    {
      id: "attributes",
      _attributes: "Giới tính",
      numeric: true,
      disablePadding: false,
      label: "Giới tính",
    },
    {
      id: "attributes",
      _attributes: "Tag",
      numeric: true,
      disablePadding: false,
      label: "Tags",
    },
    // { id: "note", numeric: true, disablePadding: false, label: "Ghi chú" },
    { id: "view", numeric: true, disablePadding: false, label: "Chi tiết" },
  ];

  itemInit() {
    const where = {};
    const and = [];
    const { filters } = this.state;
    for (const key in filters.where) {
      if (filters.where.hasOwnProperty(key)) {
        const element = filters.where[key];
        if (element) {
          switch (key) {
            case "name":
            case "status":
            case "note":
            default: {
              if (key.startsWith("from") || key.startsWith("to")) {
                if (key == "from") {
                  and.push({ time: { gte: this.state.filters.where.from } });
                  where.and = and;
                } else {
                  and.push({ time: { lte: this.state.filters.where.to } });
                  where.and = and;
                }
              } else {
                where[key] = { like: element };
              }
              break;
            }
          }
        }
      }
    }
    this.props.countListContactFile({ where: where });
    this.props.getListContactFile(
      filters.order,
      filters.pageSize,
      filters.page,
      {
        where,
      }
    );
  }

  openDialogCreate = () => {
    this.setState({ modalSend: !this.state.modalSend });
  };

  handleClose = () => {
    this.setState({
      modalSend: false,
      modalAction: false,
      modalDelete: false,
      name: "",
      note: "",
      fileName: "",
    });
  };

  openModalEdit = (item) => {
    this.state.item = item;
    this.setState({ modalAction: true });
  };

  openModalDelete = (item) => {
    this.state.item = item;
    this.setState({ modalDelete: true });
  };

  handleChangePage = (e, page) => {
    const { filters } = this.state;
    this.setState({ page });
    filters.page = page * filters.pageSize;
    this.itemInit();
  };

  handleChangeRowsPerPage = (e) => {
    const { filters } = this.state;
    filters.pageSize = e.target.value;
    this.setState(
      {
        filters,
      },
      () => {
        this.itemInit();
      }
    );
  };

  handleSearch = (e) => {
    const value = e.target.value;
    const name = e.target.name;
    const { filters } = this.state;
    filters.where[name] = value;
    this.setState({
      filters,
    });
  };
  handleSubmit = (e) => {
    if (e.key === "Enter" || e.key === undefined) {
      const { filters } = this.state;
      filters.skip = 0;
      this.setState(
        {
          disable: false,
          filters: {
            ...filters,
            page: 0,
          },
        },
        () => {
          setTimeout(() => {
            this.itemInit();
          }, 1000);
        }
      );
    }
  };

  handleDateChangeStart = (from) => {
    const { filters } = this.state;
    filters.where.from = datetimeHelper.toFormat(from, "YYYY-MM-DD");
    this.setState({ from });
  };

  handleDateChangeEnd = (to) => {
    const { filters } = this.state;
    filters.where.to = datetimeHelper.toFormat(to, "YYYY-MM-DD");
    this.setState({ to });
  };

  handleChangeText = (name) => {
    return (e) => {
      this.setState({
        [name]: e.target.value,
      });
    };
  };

  handleChangeTextEdit = (name) => {
    return (e) => {
      this.setState({
        item: {
          ...this.state.item,
          [name]: e.target.value,
        },
      });
    };
  };

  handleCreateModel = () => {
    this.setState({ modalAction: true, item: {} });
  };

  handleAction = () => {
    const { id } = this.state.item;
    if (!id) {
      const { name, note } = this.state;
      if (this.state.fileName) {
        return (
          this.props.addNewContactFile(name, note, this.state.fileName),
          setTimeout(
            function () {
              this.setState({
                modalAction: false,
                name: "",
                note: "",
                fileName: "",
              });
              this.itemInit();
            }.bind(this),
            500
          )
        );
      } else {
        this.setState({ error: true });
      }
    } else {
      const { id, name, note } = this.state.item;
      return (
        this.props.editContactFile(id, name, note, this.state.fileName),
        setTimeout(
          function () {
            this.setState({ modalAction: false, name: "", note: "" });
            this.itemInit();
          }.bind(this),
          500
        )
      );
    }
  };

  handleEdit = () => {
    const { id, name, note, fileName } = this.state.item;
    setTimeout(
      function () {
        this.setState({ modalEdit: false });
      }.bind(this),
      500
    );
  };

  handleDelete = () => {
    this.props.deleteContactFile(this.state.item.id);
    setTimeout(
      function () {
        this.setState({ modalDelete: false });
        this.itemInit();
      }.bind(this),
      500
    );
  };

  upload = (e) => {
    const data = new FormData();
    data.append("file", e.target.files[0]);
    axios
      .post(
        `${API_PROTOCOL}://${API_HOST}/${API_PATH}mini-crm/contact-file/upload`,
        data,
        {
          headers: {
            Authorization: this.state.token,
            "Content-Type": "multipart/form-data",
          },
        }
      )
      .then((res) => {
        if (!res.error) {
          this.setState({
            fileName: res.data,
            error: false,
            errorFileContact: null,
            errorMessage: "Vui lòng chọn file danh bạ",
          });
        } else {
          if (
            res.error.code &&
            res.error.code === "ERROR_FORMAT_FILE_CONTACT"
          ) {
            this.setState({
              fileName: "",
              errorFileContact: res.data.error,
              error: true,
              errorMessage: "File danh bạ không hợp lệ",
            });
          } else {
            this.setState({
              fileName: "",
              errorFileContact: null,
              error: true,
              errorMessage: "File danh bạ không hợp lệ",
            });
          }
        }
      })
      .catch((error) => {
        this.setState({
          fileName: "",
          errorFileContact: null,
          error: true,
          errorMessage: error.response?.data?.message || error.message,
        });
      });
  };

  handleConfigCampaign = (item) => {
    this.state.item = item;
    this.setState({ openModalCampaign: true });
    this.props.closeModalCampaign();
  };

  handleCloseModal = () => {
    this.setState({ openModalCampaign: false });
    // this.props.openModalNotification()
  };

  handleView = (item) => {
    this.state.contact = item;
    this.setState({ modelContact: true });
  };

  render() {
    const { classes, listContactFile, coutContactFile, listProvider } =
      this.props;
    const {
      id,
      fileName,
      note,
      name,
      filters,
      item,
      modalDelete,
      modalAction,
    } = this.state;
    const listContactFileResult =
      typeof listContactFile === "object"
        ? Object.keys(listContactFile).map((key) => listContactFile[key])
        : listContactFile;
    return (
      <React.Fragment>
        <ValidatorForm
          ref="form"
          onSubmit={this.handleSubmit}
          onError={(errors) => console.log(errors)}
          className={classes.form}>
          <Card className={classes.card}>
            <CardContent>
              <FormControl className={classes.form}>
                <FormGroup className={classes.form}>
                  <Grid container spacing={24}>
                    <Grid item md={4}>
                      <TextValidator
                        id="outlined-full-width"
                        margin="normal"
                        label="Tên file danh bạ"
                        variant="outlined"
                        className={classes.input}
                        onChange={this.handleSearch}
                        value={filters.where.name}
                        name="name"
                        onKeyPress={this.handleSubmit}
                      />
                    </Grid>
                    <Grid item md={4}>
                      <TextValidator
                        id="outlined-full-width"
                        margin="normal"
                        label="Trạng thái"
                        variant="outlined"
                        className={classes.input}
                        onChange={this.handleSearch}
                        value={filters.where.status}
                        name="status"
                        onKeyPress={this.handleSubmit}
                      />
                    </Grid>
                    <Grid item md={4}>
                      <Tooltip title="Tìm kiếm" disableFocusListener>
                        <Fab
                          color="primary"
                          aria-label="Search"
                          className={classes.fab}
                          onClick={this.handleSubmit}
                          type="submit">
                          <Search />
                        </Fab>
                      </Tooltip>
                    </Grid>
                  </Grid>
                </FormGroup>
              </FormControl>
            </CardContent>
          </Card>
        </ValidatorForm>
        <TableData
          {...this.props}
          nameTable="Danh sách file danh bạ"
          items={listContactFileResult}
          rowsPerPage={filters.pageSize}
          count={this.props.count ? this.props.count.count : 0}
          page={
            filters.pageSize === 20
              ? filters.page / 20
              : filters.pageSize === 40
              ? filters.page / 40
              : filters.pageSize === 60
              ? filters.page / 60
              : filters.pageSize === 80
              ? filters.page / 80
              : filters.page / 100
          }
          rowItems={this.listCollumns}
          allowCreate={true}
          handleEdit={this.openModalEdit}
          handleDelete={this.openModalDelete}
          handleConfig={this.handleConfigCampaign}
          handleChangePage={this.handleChangePage}
          handleChangeRowsPerPage={this.handleChangeRowsPerPage}
          createAction={
            <Tooltip title="Thêm mới" disableFocusListener>
              <Fab
                color="primary"
                aria-label="add"
                size="small"
                className={classes.fab}
                onClick={this.handleCreateModel}>
                <Add className={classes.add} />
              </Fab>
            </Tooltip>
          }
        />
        <Dialog
          open={modalDelete}
          title={`Bạn có muốn xóa file danh bạ?`}
          button={true}
          onSubmit={this.handleDelete}
          onClose={this.handleClose}
        />
        <Dialog
          open={this.state.modalAction}
          title={
            item
              ? item.id
                ? "Chỉnh sửa thông tin file danh bạ"
                : "Thêm file danh bạ"
              : null
          }
          input={
            <ValidatorForm
              ref="form"
              onSubmit={this.handleAction}
              onError={(errors) => console.log(errors)}
              className={classes.form}>
              <FormControl className={classes.form}>
                <Grid container className={classes.grid}>
                  <TextValidator
                    id="outlined-full-width"
                    margin="normal"
                    label="Tên file danh bạ"
                    variant="outlined"
                    className={classes.input}
                    autoFocus={true}
                    onChange={
                      item
                        ? item.id
                          ? this.handleChangeTextEdit("name")
                          : this.handleChangeText("name")
                        : null
                    }
                    value={item ? (item.id ? item.name : name) : null}
                    name="name"
                    validators={["required"]}
                    errorMessages="Không được để trống"
                  />
                  {item ? (
                    item.id ? (
                      <React.Fragment />
                    ) : (
                      <React.Fragment>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            paddingTop: 10,
                            paddingBottom: 10,
                          }}>
                          <Typography style={{ marginRight: 5 }}>
                            Upload danh bạ
                          </Typography>
                          <CloudUpload />
                          <input
                            type="file"
                            name="fileName"
                            id="fileName"
                            style={{ marginLeft: 15 }}
                            onChange={this.upload}
                          />
                        </div>
                        {/* <CSVLink data={csvData} filename={"sample.csv"} style={{ width: '100%', color: '#484848' }} className={classes.font}>Tải file mẫu</CSVLink> */}
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            paddingTop: 10,
                            paddingBottom: 10,
                          }}>
                          <Typography
                            className={classes.font}
                            onClick={() => {
                              if (this._exporter) {
                                this._exporter.save();
                              }
                            }}
                            style={{
                              marginLeft: 15,
                              whiteSpace: "nowrap",
                              textDecorationLine: "underline",
                            }}>
                            Tải file XLSX mẫu
                          </Typography>
                          <ExcelExport
                            data={dataExcel}
                            fileName="File danh bạ mẫu.xlsx"
                            ref={(exporter) => {
                              this._exporter = exporter;
                            }}
                            sheetName="Tên Worksheet">
                            <ExcelExportColumn
                              title="Số điện thoại"
                              field="phoneNumber"
                            />
                            <ExcelExportColumn title="Họ tên" field="name" />
                            <ExcelExportColumn title="Giới tính" field="sex" />
                            <ExcelExportColumn
                              title="Địa chỉ"
                              field="address"
                            />
                            <ExcelExportColumn title="Tag" field="tags" />
                            <ExcelExportColumn title="Số hiệu" field="number" />
                          </ExcelExport>
                        </div>
                        {this.state.error && (
                          <p className="error-messages">
                            {this.state.errorMessage}
                          </p>
                        )}
                      </React.Fragment>
                    )
                  ) : null}
                  {this.state.errorFileContact && (
                    <div>
                      <Typography
                        className={classes.font}
                        onClick={() => {
                          if (this._exporter) {
                            this._errorFileExporter.save();
                          }
                        }}
                        style={{
                          marginLeft: 15,
                          whiteSpace: "nowrap",
                          textDecorationLine: "underline",
                        }}>
                        Tải file lỗi danh bạ
                      </Typography>
                      <ExcelExport
                        data={this.state.errorFileContact.message}
                        fileName="File danh bạ lỗi.xlsx"
                        ref={(exporter) => {
                          this._errorFileExporter = exporter;
                        }}>
                        <ExcelExportColumn title="Hàng có lỗi" field="row" />
                        <ExcelExportColumn title="Nội dung" field="phoneErr" />
                      </ExcelExport>
                    </div>
                  )}
                  <TextValidator
                    id="outlined-full-width"
                    margin="normal"
                    label="Ghi chú"
                    variant="outlined"
                    className={classes.input}
                    onChange={
                      item
                        ? item.id
                          ? this.handleChangeTextEdit("note")
                          : this.handleChangeText("note")
                        : null
                    }
                    value={item ? (item.id ? item.note : note) : null}
                    name="note"
                    multiLine
                    rows={5}
                  />
                </Grid>
                {item ? (
                  item.id ? (
                    <React.Fragment>
                      <Typography
                        style={{ marginLeft: 10, marginTop: 5 }}
                        variant="h6"
                        gutterBottom>
                        Danh bạ
                      </Typography>
                      <Divider />
                      {item.contacts ? (
                        <TableData
                          {...this.props}
                          nameTable="Danh bạ"
                          items={item.contacts}
                          allowCreate={false}
                          pagination={false}
                          rowItems={this.listContact}
                          handleView={this.handleView}
                        />
                      ) : null}
                    </React.Fragment>
                  ) : (
                    ""
                  )
                ) : (
                  ""
                )}

                <DialogActions>
                  <Button
                    onClick={this.handleClose}
                    color="secondary"
                    className={classes.button}>
                    Hủy
                  </Button>
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    className={classes.button}>
                    Lưu
                  </Button>
                </DialogActions>
              </FormControl>
            </ValidatorForm>
          }
          onClose={this.handleClose}
        />
        <Dialog
          open={this.state.modelContact}
          onClose={() => this.setState({ modelContact: false })}
          buttonExit={true}
          title={`Chi tiết khách hàng ${
            this.state.contact != null ? this.state.contact.fullName : ""
          }`}
          input={
            <FormControl>
              {this.state.contact != null ? (
                <React.Fragment>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      paddingTop: 10,
                      marginBottom: 10,
                    }}>
                    <Icon>person</Icon>
                    <Typography style={{ marginLeft: 10 }}>
                      {this.state.contact.fullName} -{" "}
                      {this.state.contact.phoneNumber}
                    </Typography>
                  </div>
                  <Typography style={{ marginBottom: 10 }}>
                    Giới tính: {this.state.contact.attributes["Giới tính"]}
                  </Typography>
                  <Typography style={{ marginBottom: 10 }}>
                    Tags:{" "}
                    {this.state.contact.attributes["Tag"] &&
                    this.state.contact.attributes["Tag"].split(";").length != 0
                      ? this.state.contact.attributes["Tag"]
                          .split(";")
                          .map((i) => {
                            return <Chip label={i} className={classes.chip} />;
                          })
                      : null}
                  </Typography>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(this.state.contact.note),
                    }}
                    style={{ lineHeight: 2, marginBottom: 10 }}></div>
                </React.Fragment>
              ) : null}
            </FormControl>
          }
        />
        <DialogCampaign
          open={this.state.openModalCampaign && this.props.closeModal}
          onClose={this.handleCloseModal}
          contactFileId={
            this.state.item
              ? this.state.item.id
                ? this.state.item.id
                : ""
              : ""
          }
          type="file"
        />
      </React.Fragment>
    );
  }
}

ContactFile.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  listContactFile: state.contact.contactFiles,
  count: state.contact.countContactFile,
  contact: state.contact.contactFile,
  fileName: state.contact.fileName,
  closeModal: state.campaign.closeDialog,
});

const Campaign = connect(null, CampaignAction)(ContactFile);

ContactFile = connect(mapStateToProps, mapActionsToProps)(Campaign);

export default withStyles(styles)(ContactFile);
